/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICookieValue, ICookieContext, ICookieContextOptions } from '@msdyn365-commerce/core';
import { CookieContext } from '@msdyn365-commerce/runtime-internal/dist/types/utils/cookie-utils';

export type ICookieContextWithEssential = ICookieContext & {
    get: <T>(cookieName: string, isEssential?: boolean) => ICookieValue<T>;
    _options: ICookieContextOptions;
};

export const GetCookie = (cookies: ICookieContext | ICookieContextWithEssential, cookieName: string): string | undefined => {
    const marketCookie = (cookies as ICookieContextWithEssential).get<string>(cookieName, true);

    if (marketCookie && marketCookie.value && marketCookie.value.length > 0) {
        return marketCookie.value;
    } else {
        return undefined;
    }
};

export const SetCookie = (cookies: ICookieContext, value: string, cookieName: string, exp: number, essential: boolean = false): void => {
    if (value) {
        (cookies as CookieContext).set(cookieName, value, { path: '/', maxAge: exp, isEssential: essential });
    }
};
